export const enI18n = {
  coupon: "Coupon",
  qcoupon: "QCoupon",
  vocher: "Deduction",
  user_balance: "Balance",
  user_credit: "Credit",
  recharge: "Recharge",
  first_recharge: "First Top-Up Bonus",
  user_center: "User center",
  user_signout: "Sign out",
  expire_date: "Expiry date ",
  copy: "Copy",
  copy_success: "Copy success",
  xgt_vip_tip_0: "Not activated",
  xgt_vip_tip_1: "Activated",
  xgt_vip_expire_date: "Expiry date: ",
  xgt_vip_gift_tip: "More benefits",
  xgt_vip_button_0: "Activate",
  xgt_vip_button_1: "Renewal",
  tab_render: "Render",
  tab_desktop: "Cloud",
  desktop_coin: "Cloud coin",
};
export const zhI18n = {
  coupon: "渲染券",
  qcoupon: "青云券",
  vocher: "免单券",
  user_balance: "余额",
  user_credit: "可用额度",
  recharge: "充值",
  first_recharge: "新用户专属充值优惠",
  user_center: "个人中心",
  user_signout: "退出登录",
  expire_date: "有效期至 ",
  copy: "复制",
  copy_success: "复制成功",
  xgt_vip_tip_0: "未开通",
  xgt_vip_tip_1: "已开通",
  xgt_vip_expire_date: "有效期至：",
  xgt_vip_gift_tip: "开通会员尊享更多权益",
  xgt_vip_button_0: "开通会员",
  xgt_vip_button_1: "续期会员",
  tab_render: "云渲染",
  tab_desktop: "云制作",
  desktop_coin: "云制作币",
};

export const getTranslateNsT = (local: "zh" | "en") => {
  return (key: string) =>
    ({
      zh: zhI18n,
      en: enI18n,
    }[local][key] || "");
};
